import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import ReactModal from 'react-modal';
import Media from 'react-media';

export default class DeleteConfirmationModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool,
    contentLabel: PropTypes.string,
    relProps: PropTypes.instanceOf(Map),
    deleteRelationship: PropTypes.func,
    handleCloseModal: PropTypes.func,
  };

  _deleteRelationship = () => {
    const { deleteRelationship } = this.props;
    deleteRelationship();
  };

  render() {
    const { showModal, contentLabel, handleCloseModal, relProps } = this.props;

    const propSize = relProps.size;
    const propWord = propSize === 1 ? 'property' : 'properties';

    return (
      <Media query="(max-width: 992px)">
        {matches => (
          <ReactModal
            isOpen={showModal}
            contentLabel={contentLabel}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                overflowY: 'auto',
              },
              content: {
                marginLeft: 'auto',
                marginRight: 'auto',
                padding: 0,
                border: 'none',
                bottom: 'auto',
                borderRadius: 4,
                maxWidth: matches ? '90vw' : '60vw',
              },
            }}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#eee' }}>
                <h5 className="modal-title">{contentLabel}</h5>
                <button
                  onClick={handleCloseModal}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i
                    className="fa fa fa-times"
                    style={{ fontSize: '1.3em', color: '#808080' }}
                  />
                </button>
              </div>
              <div className="modal-body">
                <h4 className="text-danger">
                  {propSize} {propWord} found!
                </h4>
                <p>
                  Deleting this relationship will also delete it's properties.
                  Are you sure you want to delete this relationship?
                </p>
              </div>
              <div
                className="modal-footer"
                style={{ backgroundColor: '#eee', padding: 0 }}
              >
                <button
                  className="btn btn-danger modal-submit-btn"
                  onClick={this._deleteRelationship}
                  // disabled={disabled}
                >
                  Delete
                </button>
              </div>
            </div>
          </ReactModal>
        )}
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/DeleteConfirmationModal.js